<template>
    <section>
        <template>
        <div class="page-wrap">
            <div class="container">
                <div class="box-content">
                    <h2>Shopping Cart</h2>
                    <div v-if="cartItemsCount < 1">
                        <p>YOUR CART IS EMPTY</p>
                    </div>
                    <div v-else>
                        <div class="th hidden-xs">
                            <div class="row">
                                <div class="col-sm-3">PRODUCT</div>
                                <div class="col-xs-9">
                                    <div class="row sm-gutter">
                                        <div class="col-xs-6 col-sm-6 col-md-6">DESCRIPTION</div>
                                        <div class="col-xs-3 text-center">QUANTITY</div>
                                        <div class="col-xs-1 hidden-xs"></div>
                                        <div class="col-xs-3 col-sm-2 text-right">SUBTOTAL</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tb">
                            <template v-for="(item, itemIndex) in cart">
                                <div class="row">
                                    <div class="col-sm-3 cart-img">
                                        <div class="prod-container">
                                            <img v-if="item.gc" class="prod-img" src="images/giftcertificate.png"/>
                                            <img v-else class="prod-img" v-bind:src="getCartItemImage(item)"/>
                                            <div class="prod-replica">
                                                <div class="prod-replica-table cart-item">
                                                    <div class="prod-replica-table-td" v-bind:class="products[item.item_id].classes">
                                                        <p v-for="n in products[item.item_id].max_lines">{{ item.lines[n-1] }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-9">
                                        <div class="row tr sm-gutter">
                                            <div class="col-xs-6 col-sm-6 col-md-6">
												<strong v-html="products[item.item_id].description"></strong>
												<template v-if="is12x12(products[item.item_id].item_image_default || '')">
													Price:&nbsp; $&nbsp;500.00
												</template>
												<template v-if="isTree(products[item.item_id].item_image_default || '')">
													Price:&nbsp; $&nbsp;1500.00
												</template>
												<template v-if="isNook(products[item.item_id].item_image_default || '')">
													Price:&nbsp; $&nbsp;5000.00
												</template>
                                            </div>
                                            <div class="col-xs-4 text-center">
                                                <div class="wrap-count">
                                                    <div class="amount">
                                                        <span></span><span>1</span><span></span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-3 col-sm-2 text-right price">
                                                <span class="pull-left">$&nbsp;</span>
												<template v-if="is12x12(products[item.item_id].item_image_default || '')">
													500.00
												</template>
												<template v-if="isTree(products[item.item_id].item_image_default || '')">
													1500.00
												</template>
												<template v-if="isNook(products[item.item_id].item_image_default || '')">
													5000.00
												</template>
                                            </div>
                                        </div>
                                        <div class="row tr sm-gutter" v-for="(qty, childId) in item.children">
                                            <div class="col-xs-6 col-sm-6 col-md-6">
                                                <strong v-html="childProducts[item.item_id].children[childId].description"></strong>
                                                Price:&nbsp; $&nbsp; {{ childProducts[item.item_id].children[childId].price }}
                                            </div>
                                            <div class="col-xs-4 text-center">
                                                <div class="wrap-count">
                                                    <div class="amount no-select">
                                                        <span v-on:click="sub1(itemIndex, childId)" class="pointer">-</span>
                                                        <span>{{ qty }}</span>
                                                        <span v-on:click="add1(itemIndex, childId)" class="pointer">+</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-3 col-sm-2 text-right price">
                                                <span class="pull-left">$&nbsp;</span>
                                                &nbsp;{{ calcLineItemTotal(item.item_id, childId, qty) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-3 col-xs-3">
                                        <template v-if="isInscriptionAllowed && !item.gc" class="pull-left">
                                            <router-link tag="a" class="text-danger text-underline"
                                                :to="{ name: 'EditInscription', params: { id: itemIndex }}"
                                            >Edit Inscription</router-link>
                                        </template>
                                    </div>
                                    <div class="col-sm-9 col-xs-9">
                                        <a class="text-danger text-underline pointer pull-right" v-on:click="invokeItemDeletion(itemIndex)">
                                            <img src="images/bin.png" alt="Remove"><span class="pl-15 text-danger">Delete Item</span>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="text-right">
			    <strong class="subtotal">Subtotal: $&nbsp;{{ ((subTotal) + (subTotal * 0)).toFixed(2) }}</strong>
                            <p class="note">
                                <span style="font-style: italic;">
                                    Discounts, shipping and tax will be calculated at checkout.
                                </span>
                            </p>
                        </div>
                        <marketing-information ref="mi"></marketing-information>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="btn-wrap">
                                    <router-link to="/shop">
                                        <a class="btn btn-danger btn-lg">Continue Shopping</a>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="btn-wrap">
                                    <a v-on:click="onCheckout" class="btn btn-danger btn-lg pull-right">Check Out</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <deletion-confirmation-popup on-submit="onCartItemDeletionPopupSubmit"></deletion-confirmation-popup>
        </template>
    </section>
</template>

<script type="text/jsx">
    import { Event } from '../../../../assets/js/components/frontend/event.vue'
    import { mapState, mapGetters } from 'vuex'
    import CampaignConfigurationMixin from '../../../../assets/js/components/frontend/mixin/campaign-configuration.vue'
    import DeletionConfirmationPopup from '@/components/popup/deletion-confirmation.vue'
    import MarketingInformation from '@/components/content/MarketingInformation.vue'
	import ProductHandlingMixin from '@/components/mixin/product-handling.vue'
    export default {
        name: 'cart',
        mixins: [
            CampaignConfigurationMixin,
			ProductHandlingMixin
        ],
        components: {
            'deletion-confirmation-popup': DeletionConfirmationPopup,
            'marketing-information': MarketingInformation
        },
        computed: {
            ...mapState([
                'campaign'
            ]),
            ...mapGetters([
                'products', 'childProducts', 'cart', 'cartItemsCount', 'subTotal'
            ]),
            baseImagePath: function () {
                return 'images/catalog/' + this.campaign.short_url + '/';
            }
        },
        created: function () {
            Event.$on('onCartItemDeletionPopupSubmit', this.onCartItemDeletionConfirmed);
        },
        beforeDestroy: function () {
            Event.$off('onCartItemDeletionPopupSubmit' /* , this.onCartItemDeletionConfirmed */);
        },
        methods: {
            invokeItemDeletion: function (id) {
                this.invokeDeletion({
                    id: id
                });
            },
            invokeDeletion: function (payload) {
                Event.$emit('deletionConfirmationPopupInvokeModal', payload);
            },
            onCartItemDeletionConfirmed: function (payload) {
                this.$store.commit('deleteItemFromCart', payload.id);
            },
            add1: function (itemIndex, childId, delta=1) {
                this.$store.commit('changeItemQtyInCart', {
                    itemIndex,
                    childId,
                    delta
                });
            },
            sub1: function (itemIndex, childId, delta=-1) {
                this.$store.commit('changeItemQtyInCart', {
                    itemIndex,
                    childId,
                    delta
                });
            },
            calcLineItemTotal: function (prodId, childId, qty) {
                var price = 500.00;
		return (price * qty).toFixed(2);
            },
            getCartItemImage: function (cartItem) {
                var itemId = cartItem.item_id;
                var product = this.products[itemId];
                var logosList = {};
                if (this.isMultiLogoAllowed) {
                    if ("options" in product && product.options) {
                        if ("logo" in product.options && product.options.logo) {
                            logosList = product.options.logo;
                        }
                    }
                }
                var res = '';
                var logoId = 'logo' in cartItem.options ? cartItem.options.logo : '';
                if (logoId in logosList) {
                    res = this.baseImagePath + logosList[logoId].item_image_blank;
                    return res;
                }
                res = this.baseImagePath + product.item_image_blank;
                return res;
            },
            onCheckout: function () {
                this.$refs['mi'].$validator.validateAll().then((result) => {
                    console.log('marketing info validation result:', result);
                    if (!result) {
                        return;
                    }
                    this.$store.commit('updateMarketingInfo', this.$refs['mi'].$data);
                    this.$router.push({ path: '/checkout'});
                }).catch(function () {
                    console.log('adding to Cart failed due to validation errors!');
                });
            }
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// Cart.vue?dc7a7f20